/** One niche global module row in the role UI (key matches `access_config.global`). */
export interface NichePermissionModule {
  key: string;
  label: string;
}

/** Per-industry niche section for global permissions (blueprint + labels). */
export interface NichePermissionConfig {
  sectionLabel: string;
  modules: NichePermissionModule[];
}

export const DEFAULT_INDUSTRY_ID = 1;

/**
 * "Lead Management" — leads only, no niche module (no programs, variants,
 * courses or services). Its id differs per database (the server resolves it
 * by slug), so it is recognised by `industry.slug` from `useCurrentIndustry`,
 * never by number.
 */
export const LEAD_MANAGEMENT_INDUSTRY_SLUG = "lead-management";

export function isLeadManagementIndustry(
  industry: { slug?: string | null } | null | undefined
): boolean {
  return industry?.slug === LEAD_MANAGEMENT_INDUSTRY_SLUG;
}
